/**
 * App store that connects the (localStorage-only) library `SettingsStore` to the
 * `user-preferences` database service — hydrate on login, debounce-persist on
 * change. See {@link installSettingsSync} for the mechanics.
 *
 * Registered in `appStoresConfig.ts` (immediately AFTER the `settingsStore`
 * entry) so the DB wiring lives with the app's store composition instead of
 * being hardcoded into RootStore. It owns no state of its own — it just holds
 * the reaction disposer and tears it down on `dispose()` (called by
 * RootStore.disposeAll's app-store sweep).
 */
import type RootStore from "./RootStore";
import { installSettingsSync } from "./settingsSync";

export default class SettingsSyncStore {
  private readonly disposeSync: () => void;

  constructor(rootStore: RootStore) {
    this.disposeSync = installSettingsSync(rootStore);
  }

  dispose(): void {
    this.disposeSync();
  }
}
